// 個人情報取り扱い
export default '■個人情報の取り扱いについて<br>\
&nbsp;&nbsp;当サイトを通じて取得したお客さまの個人情報は、工事のお申込みに関する内容、お問い合わせ、\
その他の確認や回答をさせて頂く目的で利用いたします。<br>\
&nbsp;&nbsp;また、お客さまへの回答につきましては、当社業務委託先であるJR九州コンサルタンツ株式会社（JR九州グループ会社）から\
連絡させていただく場合がございます。<br>\
その他、個人情報の取り扱いについては<a href="https://www.jrkyushu.co.jp/privacy/" target="_blank" rel="noopener noreferrer">当社個人情報保護方針</a>をご覧ください。<br>'
